import type {
  CreateTermsTemplate,
  TermsTemplateResponseDto,
  UpdateTermsTemplate,
} from '@trellis/shared'

import { apiClient } from '@/lib/api-client'
import { request } from '@/lib/request'

export const listTermsTemplates = () =>
  request<TermsTemplateResponseDto[]>(() =>
    apiClient.api.termsTemplatesControllerListTermsTemplates(),
  )

export const createTermsTemplate = (data: CreateTermsTemplate) =>
  request<TermsTemplateResponseDto>(() =>
    apiClient.api.termsTemplatesControllerCreateTermsTemplate(data),
  )

export const updateTermsTemplate = (id: string, data: UpdateTermsTemplate) =>
  request<TermsTemplateResponseDto>(() =>
    apiClient.api.termsTemplatesControllerUpdateTermsTemplate({ id }, data),
  )

export const setDefaultTermsTemplate = (id: string) =>
  request<TermsTemplateResponseDto>(() =>
    apiClient.api.termsTemplatesControllerSetDefaultTermsTemplate({ id }),
  )

export const deleteTermsTemplate = (id: string) =>
  request<void>(() => apiClient.api.termsTemplatesControllerDeleteTermsTemplate({ id }))
